import { forwardRef } from 'react';
import DatePicker from 'react-datepicker';

import { parseISO } from 'date-fns';
import moment from 'moment';
import { Calendar3 } from 'react-bootstrap-icons';
const PrimaryDatePicker = ({
  name,
  value,
  onChange,
  format,
  formatString,
  minDate,
  maxDate,
  includeDates = [],
  startDate,
  endDate,
  selectsEnd,
  selectsStart,
  readOnly = false,
  disabled = false,
  showMonthYearPicker,
  className,
  raw = false,
  placeholder = '',
  type = 'text',
}) => {
  const datePickerFormat =
    typeof format !== 'undefined' ? format : 'yyyy-MM-dd';
  const datePickerFormatString =
    typeof format !== 'undefined' ? formatString : 'YYYY-MM-DD';

  const PrimaryCoreInput = forwardRef(({ value, onClick, onChange }, ref) => {
    return (
      <div className="input-group">
        <input
          placeholder={placeholder}
          type={type}
          name={name ? name : 'primary-date-picker-default'}
          id={name ? `${name}--id` : 'primary-date-picker-default--id'}
          className={className ? `form-control ${className}` : `form-control`}
          defaultValue={value}
          onClick={onClick}
          onChange={onChange}
          ref={ref}
          readOnly={readOnly}
          autoComplete="off"
          // style={
          //   readOnly
          //     ? {
          //         backgroundColor: 'rgba(35, 46, 60, 0.1)',
          //       }
          //     : { backgroundColor: '#fff' }
          // }
        />
        {!raw && (
          <div className={'input-group-append'}>
            <span className={'input-group-text'}>
              <Calendar3 />
            </span>
          </div>
        )}
      </div>
    );
  });

  const handleChange = (e) => {
    let date = moment(e).format(datePickerFormatString);

    if (date === 'Invalid date') {
      date = '';
    }

    onChange(date);
  };

  // Generate dates within the range
  const generateDateRange = () => {
    const min_date = new Date(minDate);
    const max_date = new Date(maxDate);
    const dates = [];
    let currentDate = new Date(min_date.getTime());
    while (currentDate <= max_date) {
      dates.push(new Date(currentDate));
      currentDate.setDate(currentDate.getDate() + 1);
    }
    return dates;
  };

  const extraDates = includeDates.length
    ? includeDates.map((date) => new Date(date))
    : [];

  // Create an array that includes all dates from minDate to maxDate and any extraDates
  const allowedDates = generateDateRange().concat(extraDates);

  return (
    <div className="primary-date-picker">
      <DatePicker
        selected={value !== '' ? new Date(value) : ''}
        dateFormat={datePickerFormat}
        name={name}
        minDate={!minDate ? null : parseISO(minDate)}
        maxDate={!maxDate ? null : parseISO(maxDate)}
        includeDates={!allowedDates.length ? null : allowedDates}
        startDate={!startDate ? null : parseISO(startDate)}
        endDate={!endDate ? null : parseISO(endDate)}
        onChange={handleChange}
        readOnly={readOnly}
        customInput={<PrimaryCoreInput name={name} type={type} />}
        showMonthDropdown
        showYearDropdown
        selectsStart={selectsStart}
        selectsEnd={selectsEnd}
        disabled={disabled}
        isEditable
        showMonthYearPicker={showMonthYearPicker}
      />
    </div>
  );
};

export default PrimaryDatePicker;
